import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './loading_animation.css';

// eslint-disable-next-line valid-jsdoc
/**
 * Loading animation component
 * @desc A loading animation with three dots that grow and shrink in order
 * @returns {Component} Loading Animation Component
 */
const LoadingAnimation = (props) => {
    const { visualProps } = props;
    let classes = styles.root;
    if (visualProps.variant) {
        const variantClass = visualProps.variant;
        classes = classNames(styles[variantClass], styles.root);
    }

    return (
        <div className={classes}>
            <div className={classNames(styles.bounceOne, styles.dot)} />
            <div className={classNames(styles.bounceTwo, styles.dot)} />
            <div className={styles.dot} />
        </div>
    );
};

LoadingAnimation.propTypes = {
    visualProps: PropTypes.object
};

LoadingAnimation.defaultProps = {
    visualProps: {}
};

// Export the Loading Animation
export { LoadingAnimation };
